var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#008080"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 16.4998V19.8332C22.6667 21.8332 21.3334 23.1665 19.3334 23.1665H12.6667C10.6667 23.1665 9.33337 21.8332 9.33337 19.8332V16.4998C9.33337 14.6865 10.4267 13.4198 12.1267 13.2065C12.3 13.1798 12.48 13.1665 12.6667 13.1665H19.3334C19.5067 13.1665 19.6734 13.1732 19.8334 13.1998C21.5534 13.3998 22.6667 14.6732 22.6667 16.4998Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8342 13.2002C19.6742 13.1735 19.5076 13.1668 19.3342 13.1668H12.6676C12.4809 13.1668 12.3009 13.1802 12.1276 13.2068C12.2209 13.0202 12.3542 12.8468 12.5142 12.6868L14.6809 10.5135C15.5942 9.60683 17.0742 9.60683 17.9876 10.5135L19.1542 11.6935C19.5809 12.1135 19.8076 12.6468 19.8342 13.2002Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 16.8335H20.6667C19.9334 16.8335 19.3334 17.4335 19.3334 18.1668C19.3334 18.9002 19.9334 19.5002 20.6667 19.5002H22.6667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.e9699c2c4b396258d1e62fc0cbe5b634.svg";
export { ForwardRef as ReactComponent };